import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  PACKAGE_LIST_PARAMS_REQUEST,
  PACKAGE_LIST_STATE,
} from 'models/package';

export interface PackageState {
  package: {
    package_list: PACKAGE_LIST_STATE;
  };
}

const initialState: PackageState = {
  package: {
    package_list: {
      records: [],
      metadata: {
        page: 1,
        limit: 50,
        page_count: 1,
        total_pages: 1,
        total_count: 1,
      },
      params: { page: 1, limit: 50 },
    },
  },
};

const packageSlice = createSlice({
  name: 'package',
  initialState,
  reducers: {
    setPackageListSuccess(
      state: PackageState,
      action: PayloadAction<PACKAGE_LIST_STATE>
    ) {
      state.package.package_list = {
        ...state.package.package_list,
        ...action.payload,
      };
    },
    setPackageListParams(
      state: PackageState,
      action: PayloadAction<PACKAGE_LIST_PARAMS_REQUEST | null>
    ) {
      state.package.package_list.params = action.payload;
    },
  },
});

// Actions
export const { setPackageListSuccess, setPackageListParams } =
  packageSlice.actions;

export default packageSlice.reducer;
